import { useEffect, useRef, useState } from "react";

export const useCountUpOnView = (target, duration = 1200) => {
  const ref = useRef(null);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        let start = 0;
        const increment = target / (duration / 16);

        const counter = setInterval(() => {
          start += increment;
          if (start >= target) {
            setValue(target);
            clearInterval(counter);
          } else {
            setValue(Math.floor(start));
          }
        }, 16);

        observer.disconnect();
      },
      { threshold: 0.4 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [target, duration]);

  return { ref, value };
};
